import React, { useEffect, useState } from "react";
import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import {
  MainSlider,

  SliderContainer,
  SliderIcon,
  WaterMark,
} from "./SliderElements";
import { useNavigate } from "react-router-dom";
import { Fade } from "react-reveal";
import {
  CONTENT_TYPES,
  SLIDER_TYPES,
} from "../../utils/Enum";
import { useRef } from "react";
import SwerlCollectionCard from "../SwerlCollectionCard/SwerlCollectionCard";

export const Slider = ({
  id,
  background,
  slides,
  heightScroll,
  onSlideClick,
  selected,
  type,
  autoScroll,
  cardRef
}) => {
  const navigate  = useNavigate();
  const [isShowAll, setShowAll] = useState(false);
  const [visibleSlides, setSlides] = useState(slides);
  const [selectedSlide, setSelected] = useState(selected);
  let interval = useRef();
  const [sliderClick, setSliderClick] = useState(false)
 

  const Slide = (direction) => {
    let slider = document.getElementById(id ? id : "slider");
    setSliderClick(true)
    switch (direction) {
      case "left":
        slider.scrollLeft = slider.scrollLeft - 500;
        break;

      case "right":
        slider.scrollLeft = slider.scrollLeft + 500;
        break;
      default:
        break;
    }
  };

 /*  useEffect(() => {
      if (slides && slides?.length > 0) {
      if (isShowAll) {
        setSlides(slides);
      } else if (!isShowAll) {
        let s = slides?.filter((slide, index) => index <= 19);
        setSlides(s);
      } 
      if (selected && id === "genres") {
        //console.log(slides[selectedSlide]);
        setSlides([slides[selectedSlide]]);
      }
    } 
    return () => {}
  }, [selectedSlide, isShowAll]); */

  const slideClick = (i) => {
    setSelected(i);
    onSlideClick(i);
  };


  const swerlVoucherSlide = () => {
    if (!visibleSlides) {
      return <WaterMark>No Users</WaterMark>;
    } else {
      return visibleSlides.map((slide, index) => {
        // //console.log(id + ' index: ' + index)
        return (
          <>
            <SwerlCollectionCard key={index} content={slide} />
          </>
        );
      });
    }
  }

  let length = visibleSlides?.length ? visibleSlides?.length : 0;

  return (
    <>
      <SliderContainer>
        {visibleSlides && !heightScroll && visibleSlides?.length >= 3 && (
          <SliderIcon style={{ left: "2%" }} onClick={() => Slide("left")}>
            <FaChevronCircleLeft />
          </SliderIcon>
        )}
        <MainSlider height={heightScroll} id={id ? id : "slider"}>
         
          {type === SLIDER_TYPES.SWERL_VOUCHER && visibleSlides && swerlVoucherSlide()}
          
          {!visibleSlides && <WaterMark>Coming Soon</WaterMark>}
        </MainSlider>
        {visibleSlides && !heightScroll && visibleSlides?.length >= 3 && (
          <SliderIcon style={{ right: "2%" }} onClick={() => Slide("right")}>
            <FaChevronCircleRight />
          </SliderIcon>
        )}
      </SliderContainer>
    </>
  );
};
